<template>
  <div class="wrap">
      <h1>Sign Up Now</h1>
      
      <form @submit="submitForm">
          <input required type="email" placeholder="Your email" v-model="email" class="u-full-width"> 
          <Select @open="recieveLocation" />
          <div class="agree">
                   <input @click="returnButton" v-model="checkbox"  required type="checkbox" id="check" name="agree">
                 <label ref="check" for="agree">I agree to the Terms of Service.</label>
          </div>
          <div class="btn">
              <button>Sign Up</button>
          </div>
      </form>
  </div>
</template>

<script>
import Select from './select-countries.vue'
export default {
 name:'SignUp',
 components:{ Select },
 data(){
  return {
      showButton: false,
      email: '',
      Location: '',
      checkbox:''
  }
 },
 methods:{
     returnButton(){
         this.$refs.check.style.color='black'
     },
     recieveLocation(value){
          this.Location = value;
     },
     async postData(url, data){
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
       const resdata = await response.json
       return resdata
     },
     submitForm(e){
         e.preventDefault();
         this.postData('https://www.spryntr.com.ng/subscribe', {email: this.email, city: this.Location})
         .then( data => console.log(data))
         .catch(err => console.log(err));
        
         this.$emit('openPopup');
         this.email =' ';
         this.Location= ' ';
         this.checkbox = false;
     }
 }
}
</script>

<style lang="scss" scoped>
 .wrap{
background: #FFFFFF;
border: 1px solid #E5E5E5;
box-shadow: 0px 20px 24px rgba(17, 17, 17, 0.06);
border-radius: 10px;
padding:40px 40px;
width:450px;
 font-family: 'DM Sans', sans-serif;

h1{
    text-align: center;
    color:#67000D;
    margin:10px 0px;
    font-weight: 700;
    font-size: 1.9em;
}
form{
    margin:10px 0px;
    input{
        margin: 10px 0px;
      border: 2px solid #EBEAED;
      outline: none;
      border-radius: 10px;
        padding:13px 10px;
         font-family: 'DM Sans', sans-serif;
    }
    .agree{
       #check{
           margin-right: 20px;  
       }
        label{
            font-size: 1em;
            color:#C0C0C0;
        }
    }
  .btn{
        margin-top:20px;
        button{
            color: white;
            font-size:18px;
            background-color: #AB0519;
            width: 100%;
            font-weight:500;
            padding:17px;
            border-radius: 10px;
            outline: none;
            border: none;
        }
    }  
}
 }
 @media (max-width:500px){
     .wrap{
         width: 100%;
     }
 }
</style>